import { AutogenModelTopmatchDetailGroup, AutogenRowTopmatchDetailGroup } from "./autogen/AutogenModelTopmatchDetailGroup";

export class ModelTopmatchDetailGroup extends AutogenModelTopmatchDetailGroup<RowTopmatchDetailGroup> {
	constructor() {
		super(RowTopmatchDetailGroup);
	}
}

export class RowTopmatchDetailGroup extends AutogenRowTopmatchDetailGroup {
}